/* eslint-disable no-extend-native */
// support toSorted syntax below chrome 87
if (!Array.prototype.toSorted) {
    Array.prototype.toSorted = function <T>(compareFn?: (a: T, b: T) => number): T[] {
        return this.slice().sort(compareFn)
    }
}
